import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5393365e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-padding-top" }, " Couldn't find any expenses that match those parameters ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_modal = _resolveComponent("edit-modal")!
  const _component_expense_modal = _resolveComponent("expense-modal")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_expense_item = _resolveComponent("expense-item")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.editModal && _ctx.user)
        ? (_openBlock(), _createBlock(_component_edit_modal, {
            key: 0,
            isOpen: _ctx.editModal,
            categories: _ctx.categories,
            expense: _ctx.selectedExpense,
            user: _ctx.user,
            onCloseModal: _ctx.handleCloseEditModal
          }, null, 8, ["isOpen", "categories", "expense", "user", "onCloseModal"]))
        : _createCommentVNode("", true),
      _createVNode(_component_expense_modal, {
        isOpen: _ctx.expenseModal,
        expense: _ctx.selectedExpense,
        edit: "",
        review: 
        _ctx.selectedExpense && _ctx.selectedExpense.approved === null ? true : false
      ,
        user: _ctx.user,
        onApproveReject: _ctx.handleApproveReject,
        onEdit: _cache[0] || (_cache[0] = 
        () => {
          _ctx.expenseModal = false;
          _ctx.editModal = true;
        }
      ),
        onCloseModal: _ctx.handleCloseExpenseModal
      }, null, 8, ["isOpen", "expense", "review", "user", "onApproveReject", "onCloseModal"]),
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_Toolbar, { title: "Search" })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-margin-top" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                "size-lg": "6",
                "offset-lg": "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { class: "ion-padding-start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((_ctx.approvedDateMode ? "Approved" : "Receipt") + " Date"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_toggle, {
                            modelValue: _ctx.approvedDateMode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.approvedDateMode) = $event)),
                            style: {"margin-bottom":"-13px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, { class: "ion-padding" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { class: "ion-margin" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { label: "From" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("From (" + _toDisplayString(_ctx.approvedDateMode ? "Approved" : "Receipt") + " Date)", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_datetime, {
                                modelValue: _ctx.from,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.from) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { label: "Until" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Until (" + _toDisplayString(_ctx.approvedDateMode ? "Approved" : "Receipt") + " Date)", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_datetime, {
                                modelValue: _ctx.until,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.until) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("User")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                modelValue: _ctx.selectedUser,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedUser) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: user.publicId,
                                      value: user.publicId
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(user.fullname), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Organizations")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                modelValue: _ctx.selectedOrganizations,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOrganizations) = $event)),
                                multiple: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (org) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: org,
                                      value: org
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(org), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Categories")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                modelValue: _ctx.selectedCategories,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                                multiple: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueCategoryNames, (cat) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: cat,
                                      value: cat
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(cat), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Status")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Approved")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_checkbox, {
                                        modelValue: _ctx.approved,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.approved) = $event)),
                                        color: "success",
                                        slot: "end"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Rejected")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_checkbox, {
                                        color: "danger",
                                        slot: "end",
                                        modelValue: _ctx.rejected,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rejected) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Pending")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_checkbox, {
                                        color: "warning",
                                        slot: "end",
                                        modelValue: _ctx.pending,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pending) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        color: "success",
                        style: {"margin":"12px"},
                        type: "submit",
                        class: "ion-float-left",
                        fill: "clear",
                        onClick: _ctx.download
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.downloadOutline,
                            slot: "icon-only"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_button, {
                        color: "success",
                        class: "ion-float-right",
                        style: {"margin":"12px"},
                        type: "submit",
                        onClick: _ctx.submit
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.searchOutline,
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createTextVNode("Search")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_button, {
                        class: "ion-float-right",
                        style: {"margin":"12px"},
                        color: "danger",
                        fill: "outline",
                        onClick: _ctx.clear
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Clear")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.expenseGroups && _ctx.expenseGroups.length)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenseGroups, (group, i) => {
                            return (_openBlock(), _createBlock(_component_ion_item_group, {
                              key: group.date
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item_divider, {
                                  class: _normalizeClass(i === 0 ? 'no-top-margin' : ''),
                                  color: "primary",
                                  sticky: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.date), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.expenses, (expense, i) => {
                                  return (_openBlock(), _createBlock(_component_expense_item, {
                                    key: i,
                                    expense: expense,
                                    showUser: "",
                                    showStatus: "",
                                    onOpenExpenseModal: _ctx.handleOpenExpenseModal
                                  }, null, 8, ["expense", "onOpenExpenseModal"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_ctx.searchClicked)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 1,
                          class: "middle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}